{
  "PRIMARY": {
    "name": "Primary",
    "icon": "\uF46E",
    "bootstrapIcon": "bi-1-circle",
    "imagePath": null,
    "color": "rgb(54, 121, 255, 0.8)"
  },
  "INTERMEDIATE": {
    "name": "Intermediate",
    "icon": "\uF7F6",
    "bootstrapIcon": "bi-fire",
    "imagePath": "assets/images/icons/sub-meters.png",
    "color": "rgb(255, 171, 0, 0.8)"
  },
  "GROSS_PRODUCTION": {
    "name": "Gross production",
    "icon": "\uF5CE",
    "bootstrapIcon": "bi-thermometer-high",
    "imagePath": "assets/images/icons/solar-panel.png",
    "color": "rgb(241, 81, 46, 0.8)"
  }
}